import { v40_base } from '../material-config/v40'
import { p20_base } from '../material-config/p20'
import { p40_base } from '../material-config/p40'
import { p80_base } from '../material-config/p80'
import { xp_base } from '../material-config/xp'
import { p30_base } from '../material-config/p30'
import { v50_22_base, v50_22_advance } from '../material-config/v50_22'
import { p100_22_base, p100_22_advance } from '../material-config/p100_22'
import { p100pro_advance, p100pro_base } from '../material-config/p100pro'
const deviceMaterialBaseKeyMap: Record<string, string[][]> = {
  uav17: p100_22_base,
  uav18: v50_22_base,
  uav14: p80_base,
  uav15: v40_base,
  uav13: p40_base,
  uav9: xp_base,
  uav10: xp_base,
  uav16: xp_base,
  uav12: p30_base,
  uav11: p20_base,
  uav23: p100pro_base,
}
const deviceMaterialAdvanceKeyMap: Record<string, string[][]> = {
  uav17: p100_22_advance,
  uav18: v50_22_advance,
  uav23: p100pro_advance,
}

export function getMaterialconfig(pro_type: string, uav: string): string[][] {
  let current: string[][] = []
  if (pro_type === '1') {
    if (deviceMaterialBaseKeyMap[uav]) {
      current = deviceMaterialBaseKeyMap[uav]
    }
  } else if (pro_type === '2') {
    if (deviceMaterialAdvanceKeyMap[uav]) {
      current = deviceMaterialAdvanceKeyMap[uav]
    }
  }
  return current
}
